import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSelector from './LanguageSelector';

const Header = ({ onSignUp, onLogin, money, onMenuOpen }) => {
  const { t } = useLanguage();

  return (
    <header 
      className="w-full py-3 md:py-4 px-3 md:px-8 flex justify-between items-center relative"
      style={{ 
        background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)',
        borderBottom: '2px solid #ffd700',
        boxShadow: '0 4px 20px rgba(0,0,0,0.5), 0 0 30px rgba(255,215,0,0.1)'
      }}
    >
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50"></div>
      
      {/* Mobile: Menu + Balance */}
      <div className="flex items-center gap-2 md:hidden">
        <button 
          onClick={onMenuOpen}
          className="p-2 rounded-lg"
          style={{ background: 'rgba(255,215,0,0.1)', border: '1px solid rgba(255,215,0,0.3)' }}
        >
          <span style={{ color: '#ffd700' }}>☰</span>
        </button>
        {money !== undefined && (
          <div 
            className="px-3 py-1 rounded-lg font-bold text-sm"
            style={{ 
              background: 'linear-gradient(145deg, rgba(0,255,136,0.2), rgba(0,204,106,0.2))',
              border: '1px solid rgba(0,255,136,0.3)',
              color: '#00ff88'
            }}
          >
            ${money.toLocaleString()}
          </div>
        )}
      </div>

      {/* Desktop: Sign Up / Login */}
      <div className="hidden md:flex items-center gap-3">
        <button 
          onClick={onSignUp}
          className="px-4 py-1.5 rounded text-sm font-semibold transition-all duration-300 hover:scale-105"
          style={{
            background: 'linear-gradient(145deg, #ffd700, #b8860b)',
            color: '#1a1a2e',
            boxShadow: '0 2px 10px rgba(255,215,0,0.3)'
          }}
        >
          {t('signUp')}
        </button>
        <button 
          onClick={onLogin}
          className="px-4 py-1.5 rounded text-sm font-semibold border transition-all duration-300 hover:scale-105"
          style={{
            borderColor: '#ffd700',
            color: '#ffd700',
            background: 'transparent'
          }}
        >
          {t('login')}
        </button>
      </div>

      {/* Center - Title */}
      <div className="text-center flex-1 md:flex-none">
        <h1 
          className="text-lg md:text-3xl font-black tracking-wider"
          style={{ 
            background: 'linear-gradient(180deg, #ffd700 0%, #ff8c00 50%, #ffd700 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontFamily: '"Playfair Display", Georgia, serif',
            letterSpacing: '2px'
          }}
        >
          <span className="hidden md:inline">♠ </span>TEXAS HOLD'EM<span className="hidden md:inline"> ♠</span>
        </h1>
        <p className="text-[10px] md:text-xs tracking-widest mt-0.5 hidden md:block" style={{ color: '#888' }}>
          {t('subtitle')}
        </p>
      </div>

      {/* Right - Language & More Games */}
      <div className="flex items-center gap-2 md:gap-3">
        <LanguageSelector />
        <button 
          className="hidden md:flex items-center gap-2 px-4 py-1.5 rounded text-sm font-semibold transition-all duration-300 hover:scale-105"
          style={{
            border: '1px solid #ffd700',
            color: '#ffd700',
            background: 'rgba(255,215,0,0.1)'
          }}
        >
          <span>🎰</span>
          {t('moreGames')}
        </button>
      </div>
    </header>
  );
};

export default Header;
